import React from 'react';
import './Results.css';

const Results = ({ results, formData }) => {
  // Se não houver resultados, não mostrar nada
  if (!results) return null;
  
  // Função para formatar valores monetários
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };
  
  // Função para formatar percentuais
  const formatPercentage = (value) => {
    return `${value.toFixed(2)}%`;
  };
  
  return (
    <div className="results-container">
      <h3>Resultados da Simulação</h3>
      
      <div className="results-layout">
        <div className="results-main">
          <div className="primary-result">
            <div className="result-card large">
              <div className="result-title">Valor Total Final</div>
              <div className="result-value highlight">{formatCurrency(results.finalAmount)}</div>
            </div>
          </div>
          
          <div className="secondary-results">
            <div className="result-card">
              <div className="result-title">Total Investido</div>
              <div className="result-value">{formatCurrency(results.investedAmount)}</div>
            </div>
            
            <div className="result-card">
              <div className="result-title">Juros Acumulados</div>
              <div className="result-value">{formatCurrency(results.interestAmount)}</div>
            </div>
            
            <div className="result-card">
              <div className="result-title">Rentabilidade</div>
              <div className="result-value">{formatPercentage(results.returnRate)}</div>
            </div>
          </div>
        </div>
        
        {results.taxAmount > 0 && (
          <div className="tax-section">
            <div className="result-card tax-card">
              <div className="result-title">Imposto Estimado</div>
              <div className="result-value">{formatCurrency(results.taxAmount || 0)}</div>
            </div>
            
            <div className="result-card tax-card">
              <div className="result-title">Valor Líquido</div>
              <div className="result-value highlight-secondary">{formatCurrency(results.netAmount || results.finalAmount)}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Results;